export default __webpack_public_path__ + "tmp_src/components/QuantitySelector/QuantitySelector.css.liquid";